import { POSTFORM, POST, GET } from '@/utils/request'
import Api from './url'
export const getTrainSearchList = async (params: object) => {
  return await POST({ url: Api.getTrainSearchList, data: params, showError: false })
}
